import React, { createContext, useContext, useState } from "react";
import { STRINGS } from "@/strings";

const LangCtx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("es");
  const L = (en, es) => (lang === "es" ? es : en);
  const t = STRINGS[lang];
  return <LangCtx.Provider value={{ lang, setLang, L, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
